export const pages = ['form', 'success-page'] as const;
